import styled from 'styled-components'
import { getProcessFlowCircleStyles } from '../style'
import { ProcessFlowCircleProps } from '../types'

/**
 * A styled circle component for process flow visualization
 * Supports current, upcoming, and completed states and different sizes
 */
const StyledProcessFlowCircle = styled.div.withConfig({
    shouldForwardProp: (prop) => !['status', 'size', 'color'].includes(prop)
})<ProcessFlowCircleProps>(
    ({ theme, status = 'UPCOMING', size = 'md', color }) =>
        getProcessFlowCircleStyles({ theme, status, size, color })
)

export default StyledProcessFlowCircle
